<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="thisMonth"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">URL</div></template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #name="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #postponed="{ row }">{{ row[1].postponed }}</template>
        <template #dp="{ row }">{{ row[1].deposit_paid }}</template>
        <template #fp="{ row }">{{ row[1].full_paid }}</template>
        <template #completed="{ row }">{{ row[1].completed }}</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { getLeadsAnalyticsSalesUrls } from '@/http'
export default {
  name: 'CRMAnalyticsURLsSales',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      table: {
        items: [],
        columns: ['index', 'name', 'count', 'postponed', 'dp', 'fp', 'completed', 'amount', 'commission'],
        options: {
          headings: {
            'index': '#',
            'name': 'URL',
            'count': 'Count',
            'postponed': 'Postponed',
            'dp': 'Deposit paid',
            'fp': 'Full paid',
            'completed': 'Completed',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchItems()
      })
    }, 0)
  },
  methods: {
    fetchItems() {
      getLeadsAnalyticsSalesUrls({from_date: this.filter_dates.start, to_date: this.filter_dates.end})
        .then(response => {
          this.table.items = Object.entries(response.data.instances)
          this.is_loaded = true
        })
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
  }
}
</script>
